<template>
    <div>
        <el-card shadow="hover">
            <div>
                <template style="float: left;">
                    <el-button type="primary" size="small" icon="el-icon-document-add" v-has="'PlatAdmin'" @click="doAdd()">添加</el-button>
                    <el-button-group style="margin-left:20px;" v-show="selRows.length > 0">
                        <el-tooltip v-has="'PlatAdmin'" effect="dark" content="删除" placement="top">
                            <el-button size="small" icon="el-icon-delete" @click="doDelete()"></el-button>
                        </el-tooltip>
                    </el-button-group>
                </template>
                <el-form style="float: right" inline :model="query" size="small">
                    <div @keydown.enter="doQuery()">
                        <el-form-item>
                            <el-input v-model="query.name" clearable placeholder="计划名称" style="width:150px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="query.bno" clearable placeholder="招聘批次" style="width:150px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="查询" placement="top">
                                <el-button type="warning" size="small" icon="el-icon-search" circle @click="doQuery"></el-button>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="清空查询条件" placement="top">
                                <el-button size="small" icon="el-icon-refresh" circle @click="doReset"></el-button>
                            </el-tooltip>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </el-card>
        <!--Table-->
        <el-card shadow="hover" style="margin-top: 10px;">
            <el-table ref="table" v-loading="tableLoading" :data="datas" highlight-current-row :border="true" stripe tooltip-effect="dark" @selection-change="doSelectionChange" style="width: 100%">
                <el-table-column type="selection" width="40" />
                <el-table-column show-overflow-tooltip label="招聘信息" width="300">
                    <template slot-scope="scope">
                        <span>{{ scope.row.name }}</span>
                        <br />
                        <span>[{{ scope.row.bno }}]</span>

                        <span style="margin-left: 10px;" v-html="$options.filters.planStage(scope.row.stage)"></span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="报名时间">
                    <template slot-scope="scope">
                        开始：
                        <span>{{ scope.row.regs }}</span>
                        <br />
                        截至：
                        <span>{{ scope.row.rege }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="缴费时间">
                    <template slot-scope="scope">
                        截至：
                        <span>{{ scope.row.paye }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="考试时间">
                    <template slot-scope="scope">
                        开始：
                        <span>{{ scope.row.exams }}</span>
                        <br />
                        结束：
                        <span>{{ scope.row.exame }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="准考证打印">
                    <template slot-scope="scope">
                        开始：
                        <span>{{ scope.row.prints }}</span>
                        <br />
                        截至：
                        <span>{{ scope.row.printe }}</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" width="300" label="操作">
                    <template slot-scope="scope">
                        <div>
                            <el-button size="mini" icon="el-icon-edit" v-has="'PlatAdmin'" @click.stop="doEdit(scope.row)">
                                编辑
                            </el-button>
                            <el-button size="mini" icon="el-icon-message" v-has="'PlatAdmin'" @click.stop="doOpenSms(scope.row)">
                                短信
                            </el-button>
                            <el-button size="mini" icon="el-icon-download" v-has="'PlatAdmin'" @click.stop="doExportafter(scope.row)">
                                导出
                            </el-button>
                        </div>

                        <div style="margin-top: 10px;">
                            <el-button size="mini" icon="el-icon-postcard" v-has="'PlatAdmin'" @click.stop="doOpenPost(scope.row)">
                                岗位
                            </el-button>
                            <el-button size="mini" icon="el-icon-office-building" v-has="'PlatAdmin'" @click.stop="doOpenVenues(scope.row)">
                                考点
                            </el-button>
                            <el-button size="mini" icon="el-icon-s-grid" v-has="'PlatAdmin'" @click.stop="doOpenSeats(scope.row)">
                                排座
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-card shadow="hover" v-show="this.data.pages > 1" style="margin-top: 10px;">
            <el-pagination
                background
                @current-change="doChangePage"
                @size-change="doChangeSize"
                :current-page="this.data.page"
                :page-sizes="[10, 30, 50, 100]"
                :page-size="this.query.size"
                layout="-> ,total,  prev, pager, next, jumper, sizes"
                :total="this.data.rows"
            />
        </el-card>
        <!--Form-->
        <el-dialog title="招聘计划详情" :visible.sync="formDialog" fullscreen :close-on-click-modal="false" :close-on-press-escape="false">
            <el-form ref="form" :model="field" label-position="top" :rules="rules">
                <el-tabs type="border-card" v-model="tabActivate">
                    <el-tab-pane label="招聘计划信息" name="info">
                        <el-row :gutter="10">
                            <el-col :span="20">
                                <el-row :gutter="10">
                                    <el-col :span="4">
                                        <el-form-item label="计划批次" prop="bno">
                                            <el-input v-model="field.bno" placeholder="请填写招聘批次"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="2">
                                        <el-form-item label="准考证批次" prop="zno">
                                            <el-input v-model="field.zno" type="number" placeholder="请填写准考证批次" min="0" max="9" maxlength="1"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="10">
                                        <el-form-item label="计划名称" prop="name">
                                            <el-input v-model="field.name" placeholder="请填写招聘计划名称"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="4">
                                        <el-form-item label="审核模式" prop="shenhe">
                                            <el-select v-model="field.shenhe" placeholder="请选择审核模式" style="width:100%;">
                                                <el-option label="自动审核" value="auto"></el-option>
                                                <el-option label="人工审核" value="manual"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="4">
                                        <el-form-item label="计划阶段" prop="stage">
                                            <el-select v-model="field.stage" placeholder="请选择招聘阶段" style="width:100%;">
                                                <el-option label="报名阶段" value="Register"></el-option>
                                                <el-option label="笔试阶段" value="Wexam"></el-option>
                                                <el-option label="面试阶段" value="Iview"></el-option>
                                                <el-option label="已完成" value="Finish"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-form-item label="招聘公告" prop="note">
                                    <Tinymce ref="noteEditor" v-model="field.note" :minh="610"></Tinymce>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item label="报名开始时间" prop="regs">
                                    <el-date-picker style="width: 100%;" v-model="field.regs" type="datetime" :editable="false" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择报名开始时间"></el-date-picker>
                                </el-form-item>
                                <el-form-item label="报名截至时间" prop="rege">
                                    <el-date-picker style="width: 100%;" v-model="field.rege" type="datetime" :editable="false" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择报名截至时间"></el-date-picker>
                                </el-form-item>
                                <el-form-item label="缴费截至时间" prop="paye">
                                    <el-date-picker style="width: 100%;" v-model="field.paye" type="datetime" :editable="false" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择缴费截至时间"></el-date-picker>
                                </el-form-item>
                                <el-form-item label="准考证打印开始时间" prop="prints">
                                    <el-date-picker style="width: 100%;" v-model="field.prints" type="datetime" :editable="false" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择打印开始时间"></el-date-picker>
                                </el-form-item>
                                <el-form-item label="准考证打印截至时间" prop="printe">
                                    <el-date-picker style="width: 100%;" v-model="field.printe" type="datetime" :editable="false" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择打印截至时间"></el-date-picker>
                                </el-form-item>
                                <el-form-item label="考试开始时间" prop="exams">
                                    <el-date-picker style="width: 100%;" v-model="field.exams" type="datetime" :editable="false" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择考试开始时间"></el-date-picker>
                                </el-form-item>
                                <el-form-item label="考试结束时间" prop="exame">
                                    <el-date-picker style="width: 100%;" v-model="field.exame" type="datetime" :editable="false" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择考试结束时间"></el-date-picker>
                                </el-form-item>
                                <el-form-item label="入场截至时间" prop="ine">
                                    <el-date-picker style="width: 100%;" v-model="field.ine" type="datetime" :editable="false" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择入场截至时间"></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="报名表填报字段" name="regf">
                        <el-row :gutter="10">
                            <el-col :span="18">
                                <codemirror v-model="field.regf" :options="{ tabSize: 2, mode: { name: 'javascript', json: true }, lineNumbers: true, lineWrapping: true }"></codemirror>
                            </el-col>
                            <el-col :span="6">
                                <p style="font-size:1.5em; text-align: center; width: 100%;">字段说明</p>
                                <p>【id】[字符] 字段ID</p>
                                <div>
                                    <p>【ft】[字符] 字段类型</p>
                                    <ul style="margin-left: 50px;">
                                        <li>text：单行文本</li>
                                        <li>bool：是否选择</li>
                                        <li>select：多项选择</li>
                                        <li>textarea：多行文本</li>
                                        <li>idno：身份证</li>
                                        <li>image：图片上传</li>
                                        <li>mobile：手机号码</li>
                                    </ul>
                                </div>
                                <p>【lb】[字符] 字段名称</p>
                                <p>【ht】[字符] 字段提示信息</p>
                                <p>【dv】[字符] 字段可选值</p>
                                <p>【mn】[整数] 字段值最小长度</p>
                                <p>【mx】[整数] 字段值最大长度</p>
                                <p>【rq】[真假] 字段是否必填，取值true/false</p>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="报名表填报模板" name="regw">
                        <codemirror v-model="field.regw" :options="{ tabSize: 2, mode: 'text/html', lineNumbers: true, lineWrapping: true }"></codemirror>
                    </el-tab-pane>
                    <el-tab-pane label="报名表打印模板" name="regt">
                        <codemirror v-model="field.regt" :options="{ tabSize: 2, mode: 'text/html', lineNumbers: true, lineWrapping: true }"></codemirror>
                    </el-tab-pane>
                    <el-tab-pane label="准考证打印模板" name="zkzt">
                        <codemirror v-model="field.zkzt" :options="{ tabSize: 2, mode: 'text/html', lineNumbers: true, lineWrapping: true }"></codemirror>
                    </el-tab-pane>
                    <el-tab-pane label="准考证App展示模板" name="zkza">
                        <codemirror v-model="field.zkza" :options="{ tabSize: 2, mode: 'text/html', lineNumbers: true, lineWrapping: true }"></codemirror>
                    </el-tab-pane>
                    <el-tab-pane label="座次表打印模板" name="zcbt">
                        <codemirror v-model="field.zcbt" :options="{ tabSize: 2, mode: 'text/html', lineNumbers: true, lineWrapping: true }"></codemirror>
                    </el-tab-pane>
                    <el-tab-pane label="进场照片查看模板" name="zcbp">
                        <codemirror v-model="field.zcbp" :options="{ tabSize: 2, mode: 'text/html', lineNumbers: true, lineWrapping: true }"></codemirror>
                    </el-tab-pane>
                    <el-tab-pane label="座次表App展示模板" name="zcba">
                        <codemirror v-model="field.zcba" :options="{ tabSize: 2, mode: 'text/html', lineNumbers: true, lineWrapping: true }"></codemirror>
                    </el-tab-pane>
                    <el-tab-pane label="面试通知单打印模板" name="notice">
                        <codemirror v-model="field.notice" :options="{ tabSize: 2, mode: 'text/html', lineNumbers: true, lineWrapping: true }"></codemirror>
                    </el-tab-pane>
                    <el-tab-pane label="报名信息导出字段" name="expf">
                        <el-row :gutter="10">
                            <el-col :span="18">
                                <codemirror v-model="field.expf" :options="{ tabSize: 2, mode: { name: 'javascript', json: true }, lineNumbers: true, lineWrapping: true }"></codemirror>
                            </el-col>
                            <el-col :span="6">
                                <p style="font-size:1.5em; text-align: center; width: 100%;">字段说明</p>
                                <p>【id】[字符] 字段ID</p>
                                <p>【lb】[字符] 字段标题</p>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                </el-tabs>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="submitLoading" size="medium" icon="el-icon-circle-check" @click="doSubmit">
                    保存
                </el-button>
                <el-button type="info" plain size="medium" icon="el-icon-switch-button" @click="formDialog = false">
                    关闭
                </el-button>
            </span>
        </el-dialog>
        <!-- 招聘岗位 -->
        <el-dialog title="招聘岗位" :visible.sync="postDialog" v-if="postDialog" fullscreen :close-on-click-modal="false" :close-on-press-escape="false">
            <PlanPost :pid="currentPlan"></PlanPost>
        </el-dialog>
        <!-- 招聘岗位 -->
        <el-dialog title="考点信息" :visible.sync="venuesDialog" v-if="venuesDialog" fullscreen :close-on-click-modal="false" :close-on-press-escape="false">
            <PlanVenues :pid="currentPlan"></PlanVenues>
        </el-dialog>
        <!-- 考场排座 -->
        <el-dialog title="考场排座" :visible.sync="seatsDialog" v-if="seatsDialog" fullscreen :close-on-click-modal="false" :close-on-press-escape="false">
            <PlanSeats :pid="currentPlan"></PlanSeats>
        </el-dialog>
        <!-- 群发短信 -->
        <el-dialog title="发送短信" :visible.sync="smsDialog" v-if="smsDialog" width="950px" :close-on-click-modal="false" :close-on-press-escape="false">
            <el-form>
                <el-form-item label="接收范围">
                    <el-radio-group v-model="smsType">
                        <el-radio label="Wait">未审核</el-radio>
                        <el-radio label="Reject">未通过</el-radio>
                        <el-radio label="Pass">未缴费</el-radio>
                        <el-radio label="Paid">已缴费</el-radio>
                        <el-radio label="Finish">已排座</el-radio>
                        <el-radio label="Zkz">未打印准考证</el-radio>
                        <el-radio label="Msd">未打印面试单</el-radio>
                        <el-radio label="Mob">自定义</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="手机号码" v-show="smsType === 'Mob'">
                    <el-input type="textarea" rows="3" v-model="smsMobs" placeholder="请填写手机号码，多个以`,`区分"></el-input>
                    <p style="color: red;">请填写该计划报名考生手机号，本计划不存在的号码则自动忽略</p>
                </el-form-item>
                <el-form-item label="短信内容">
                    <el-input type="textarea" rows="3" v-model="smsInfo" placeholder="请填写短信内容，短信前默认添加：考生报名序号：XXXXXXX，"></el-input>
                    <p style="color: red;">短信前默认添加：（考生报名序号：XXXXXXX，）</p>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="submitLoading" size="medium" icon="el-icon-message" @click="doSendSms">
                    发送
                </el-button>
                <el-button type="info" plain size="medium" icon="el-icon-switch-button" @click="smsDialog = false">
                    关闭
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Tinymce from '@/comps/Tinymce'
window.tinymce.baseURL = '/scripts/tinymce'

import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/mode/htmlmixed/htmlmixed.js'
import 'codemirror/mode/xml/xml.js'
import CryptoJS from 'crypto-js'

import PlanPost from '@/comps/PlanPost'
import PlanVenues from '@/comps/PlanVenues'
import PlanSeats from '@/comps/PlanSeats'

const defaultQuery = {
    page: 1,
    size: 10,
    time: 0,
    name: '',
    bno: '',
    zno: ''
}
const defaultField = {
    id: '',
    name: '',
    bno: '',
    zno: '',
    stage: 'Register',
    shenhe: 'auto',
    note: '',
    regs: '',
    rege: '',
    paye: '',
    prints: '',
    printe: '',
    exams: '',
    exame: '',
    ine: '',
    zkzt: '',
    zkza: '',
    regt: '',
    zcbt: '',
    zcba: '',
    zcbp: '',
    regw: '',
    notice: '',
    regf: `[
    {
        "id": "[String]字段ID",
        "ft": "[String]字段类型，text：单行文本，bool：是否选择，select：多项选择，textarea：多行文本，idno：身份证，image：图片上传，mobile：手机号码",
        "lb": "[String]字段名称",
        "ht": "[String]字段提示信息",
        "dv": "[String]字段值",
        "mn": "[int]最小长度",
        "mx": "[int]最大长度",
        "rq": "[bool]是否必填"
    }
]`,
    expf: `[
    {
        "id": "[String]读取字段ID",        
        "lb": "[String]标题"        
    }
]`
}
export default {
    name: 'RecPlan',
    components: {
        PlanPost,
        PlanVenues,
        PlanSeats,
        Tinymce,
        codemirror
    },
    data() {
        return {
            query: {
                ...defaultQuery
            },
            data: {
                rows: 0,
                pages: 0,
                page: 1,
                time: 0
            },
            tableLoading: false,
            datas: [],
            selRows: [],
            field: {
                ...defaultField
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: '请填写计划名称',
                        trigger: 'blur'
                    }
                ],
                bno: [
                    {
                        required: true,
                        message: '请填写招聘批次',
                        trigger: 'blur'
                    }
                ],
                zno: [
                    {
                        required: true,
                        message: '请填写准考证批次',
                        trigger: 'blur'
                    }
                ],
                note: [
                    {
                        required: true,
                        message: '请填写招聘公告',
                        trigger: 'blur'
                    }
                ],
                regs: [
                    {
                        required: true,
                        message: '请填写报名开始时间',
                        trigger: 'blur'
                    }
                ],
                rege: [
                    {
                        required: true,
                        message: '请选择报名截至时间',
                        trigger: 'blur'
                    }
                ],
                paye: [
                    {
                        required: true,
                        message: '请选择缴费截至时间',
                        trigger: 'blur'
                    }
                ],
                prints: [
                    {
                        required: true,
                        message: '请选择准考证打印开始时间',
                        trigger: 'blur'
                    }
                ],
                printe: [
                    {
                        required: true,
                        message: '请选择准考证打印截至时间',
                        trigger: 'blur'
                    }
                ],
                exams: [
                    {
                        required: true,
                        message: '请选择考试开始时间',
                        trigger: 'blur'
                    }
                ],
                exame: [
                    {
                        required: true,
                        message: '请选择考试结束时间',
                        trigger: 'blur'
                    }
                ],
                ine: [
                    {
                        required: true,
                        message: '请选择入场截至时间',
                        trigger: 'blur'
                    }
                ],
                zkzt: [
                    {
                        required: true,
                        message: '请填写准考证打印模板',
                        trigger: 'blur'
                    }
                ],
                regt: [
                    {
                        required: true,
                        message: '请填写报名表打印模板',
                        trigger: 'blur'
                    }
                ],
                zcbt: [
                    {
                        required: true,
                        message: '请填写座次表打印模板',
                        trigger: 'blur'
                    }
                ],
                zcbp: [
                    {
                        required: true,
                        message: '请填写座次表预览模板',
                        trigger: 'blur'
                    }
                ],
                regw: [
                    {
                        required: true,
                        message: '请填写报名表表单内容',
                        trigger: 'blur'
                    }
                ],
                regf: [
                    {
                        required: true,
                        message: '请填写报名表字段',
                        trigger: 'blur'
                    }
                ]
            },
            formDialog: false,
            submitLoading: false,
            postDialog: false,
            venuesDialog: false,
            seatsDialog: false,
            currentPlan: '',
            tabActivate: 'info',
            smsDialog: false,
            smsType: 'UnAudit',
            smsMobs: '',
            smsInfo: ''
        }
    },
    filters: {
        planStage: value => {
            switch (value) {
                case 'Register':
                    return '<b style="color:#FF6600;">报名阶段</b>'
                case 'Wexam':
                    return '<b style="color:#336699;">笔试阶段</b>'
                case 'Iview':
                    return '<b style="color:#993399;">面试阶段</b>'
                case 'Finish':
                    return '<b style="color:#339999;">已结束</b>'
                default:
                    return value
            }
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['招聘管理', '招聘计划'])
        this.init()
    },
    methods: {
        init() {
            this.doLoad()
        },
        doLoad() {
            this.tableLoading = true
            this.$http
                .get('/ops/recruit/plan/list', {
                    params: this.query
                })
                .then(result => {
                    this.tableLoading = false
                    if (result.data.page === 1) {
                        this.query.time = result.data.time
                    }
                    this.data = result.data
                    this.datas = result.datas
                })
        },
        doQuery() {
            this.query.page = 1
            this.doLoad()
        },
        doReset() {
            this.query = {
                ...defaultQuery
            }
            this.doQuery()
        },
        doChangePage(num) {
            this.query.page = num
            this.doLoad()
        },
        doChangeSize(num) {
            this.query.page = 1
            this.query.size = num
            this.doLoad()
        },
        doSelectionChange(rows) {
            this.selRows = rows
        },
        clearFields() {
            this.field = {
                ...defaultField
            }
            this.tabActivate = 'info'
            if (this.$refs.noteEditor) {
                this.$refs.noteEditor.setContent('')
            }
            if (this.$refs['form']) {
                this.$refs['form'].resetFields()
                this.$refs['form'].clearValidate()
            }
        },
        doOpenPost(item) {
            this.currentPlan = item.id
            this.postDialog = true
        },
        doOpenVenues(item) {
            this.currentPlan = item.id
            this.venuesDialog = true
        },
        doOpenSeats(item) {
            this.currentPlan = item.id
            this.seatsDialog = true
        },
        doAdd() {
            this.clearFields()
            this.formDialog = true
        },
        doEdit(item) {
            this.clearFields()
            this.$http
                .get('/ops/recruit/plan/detail', {
                    params: {
                        id: item.id
                    }
                })
                .then(result => {
                    this.field = {
                        ...result.data
                    }
                    this.formDialog = true
                    if (this.$refs.noteEditor) {
                        this.$refs.noteEditor.setContent(this.field.note)
                    }
                })
        },
        doSubmit() {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    this.tmpNote = this.field.note
                    this.field.note = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(this.field.note))
                    // this.field.note = encodeURI(this.field.note)
                    this.submitLoading = true
                    this.$http.post('/ops/recruit/plan/save', this.field).then(result => {
                        this.submitLoading = false
                        if (result.code === 0) {
                            this.doLoad()
                            this.formDialog = false
                            this.$message.success('保存成功')
                        } else {
                            this.field.note = this.tmpNote
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                }
            })
        },
        doDelete(item) {
            let names = []
            let ids = []
            if (item) {
                names.push(item.name)
                ids.push(item.id)
            } else {
                this.selRows.forEach(row => {
                    names.push(row.name)
                    ids.push(row.id)
                })
            }
            if (ids.length === 0) {
                this.$message.error('请选择要删除的内容')
                return
            }
            this.$confirm('是否删除[' + names.join() + ']?删除后将无法恢复', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .post('/ops/recruit/plan/delete', {
                        ids: ids.join()
                    })
                    .then(result => {
                        if (result.code === 0) {
                            this.$message.success('删除成功')
                            this.doLoad()
                        }
                    })
            })
        },
        doOpenSms(item) {
            this.currentPlan = item.id
            this.smsType = 'Wait'
            this.smsInfo = ''
            this.smsMobs = ''
            this.smsDialog = true
        },
        doSendSms() {
            if (!this.smsInfo) {
                this.$message.error('请填写要发送的内容')
                return
            }
            if (this.smsType === 'Mob' && !this.smsMobs) {
                this.$message.error('请填写接收短信的手机号码')
                return
            }
            this.$http
                .post('/ops/recruit/plan/regs/sms', {
                    id: this.currentPlan,
                    type: this.smsType,
                    mobs: this.smsMobs,
                    info: this.smsInfo
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success(result.msg)
                        this.smsDialog = false
                    }
                })
        },
        doExportafter(item) {
            this.$confirm('是否需要导出报名人员照片数据?', '请选择', {
                confirmButtonText: '需要',
                cancelButtonText: '不需要',
                type: 'warning'
            })
                .then(() => {
                    this.doExport(item, false)
                })
                .catch(() => {
                    this.doExport(item, true)
                })
        },
        doExport(item, eimg) {
            let eimgtext
            if (eimg) {
                eimgtext = '(不包含照片)'
            } else {
                eimgtext = '(包含照片)'
            }
            this.$confirm('导出报名信息可能耗费较长时间，请耐心等待' + eimgtext, '提示', {
                confirmButtonText: '开始导出',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .post('/ops/recruit/plan/regs/export', {
                        id: item.id,
                        eimg: eimg
                    })
                    .then(result => {
                        if (result.code === 0) {
                            this.$message.success('导出成功')
                            this.$alert('文件已导出，请<a href="' + result.data.url + '">点击下载</a>导出文件，或右键另存为到本地', '下载文件', {
                                dangerouslyUseHTMLString: true
                            })
                        }
                    })
            })
        }
    }
}
</script>

<style>
.CodeMirror {
    border: 1px solid #eee;
    height: auto;
    min-height: 500px;
    max-height: 600px;
}

.CodeMirror-scroll {
    height: auto;
    min-height: 500px;
    max-height: 600px;
    overflow-y: hidden;
    overflow-x: auto;
}
</style>
